<template>
    <sides-lip ref="SidesLip" @sidesClose="sidesClose">
        <div slot="soltForm">
            <el-form :model="dataForm" :rules="dataRule" size="small" ref="dataForm" label-width="160px"
                v-loading="dataLoading" style="width: 100%" element-loading-spinner="el-icon-loading">
                <el-row>
                    <el-col :span="18">
                        <el-form-item :label="$t('product_number')" prop="productNumber">
                            <el-input v-model="dataForm.productNumber" :placeholder="$t('product_number')" size="small"
                                style="width: 100%" maxlength="30" disabled></el-input>
                        </el-form-item>
                        <el-row>
                            <el-col :span="20">
                                <el-form-item>
                                    <span slot="label"><label style="color: #e94016">*</label> L*a*b*</span>
                                    <el-row>
                                        <el-col :span="6">
                                            <el-form-item prop="lAve">
                                                <el-input v-model="dataForm.lAve" placeholder="L*" class="w150 mr10"
                                                    size="small" @input="getHex()" clearable maxlength="30"
                                                    disabled></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="6">
                                            <el-form-item prop="aAve">
                                                <el-input v-model="dataForm.aAve" placeholder="a*" class="w150 mr10"
                                                    size="small" @input="getHex()" clearable maxlength="30"
                                                    disabled></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="6">
                                            <el-form-item prop="bAve">
                                                <el-input v-model="dataForm.bAve" placeholder="b*" class="w150 mr10"
                                                    size="small" @input="getHex()" clearable maxlength="30"
                                                    disabled></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-form-item>
                            </el-col>
                            <el-col :span="4">
                                <div :class="isDisabled ? 'disabled-color-preview' : 'color-preview'
                                    " v-if="dataForm.picUrl || dataForm.hex">
                                    <div v-if="dataForm.hex" :style="{
                                        backgroundColor: dataForm.hex,
                                        height: '100%',
                                        minWidth: '100%'
                                    }"></div>
                                    <img v-else :src="dataForm.picUrl" width="100%" height="100%" />
                                </div>
                            </el-col>
                        </el-row>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="" label-width="10px">
                            <image-upload :uploadImages="dataForm.productImages" :isDisabled="isDisabled">
                            </image-upload>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-form-item label="">
                    <el-collapse @change="handleChange">
                        <el-collapse-item>
                            <span class="collapse-title" slot="title">{{
                                $t('view_detailed_color')
                            }}</span>
                            <div>
                                <ul class="productLAB">
                                    <li>
                                        <span class="title">{{ $t('multi-angle') }} L*A*B*</span>
                                    </li>
                                    <li>
                                        <span class="title">{{ $t('angle') }}</span>
                                        <span v-for="x in productLAB.title" class="w100">{{
                                            x
                                        }}</span>
                                    </li>
                                    <li v-for="(x, index) in productLAB.data">
                                        <span class="title">{{ x }}</span>
                                        <el-input v-model="dataForm[`l${index + 1}`]" placeholder="L*" class="w100"
                                            :disabled="isDisabled"></el-input>
                                        <el-input v-model="dataForm[`a${index + 1}`]" placeholder="a*" class="w100"
                                            :disabled="isDisabled"></el-input>
                                        <el-input v-model="dataForm[`b${index + 1}`]" placeholder="b*" class="w100"
                                            :disabled="isDisabled"></el-input>
                                    </li>
                                    <li v-if="olabShow">
                                        <span class="title">{{ $t('integrating_sphere') }}L*A*B*</span>
                                    </li>
                                    <li v-if="olabShow">
                                        <span class="title">{{ $t('angle') }}</span>
                                        <span v-for="x in productLAB.title" class="w100">{{
                                            x
                                        }}</span>
                                    </li>
                                    <li v-if="olabShow">
                                        <span class="title" style="line-height: 1.2">
                                            D65/10°
                                            <br />
                                            <span class="ptitle">SPIN({{ $t('includes_mirror_reflection') }})</span>
                                        </span>
                                        <el-input v-model="dataForm[`lo`]" placeholder="L*" class="w100"
                                            :disabled="isDisabled"></el-input>
                                        <el-input v-model="dataForm[`ao`]" placeholder="a*" class="w100"
                                            :disabled="isDisabled"></el-input>
                                        <el-input v-model="dataForm[`bo`]" placeholder="b*" class="w100"
                                            :disabled="isDisabled"></el-input>
                                    </li>
                                </ul>
                            </div>
                        </el-collapse-item>
                    </el-collapse>
                </el-form-item>
                <div class="ces-main">
                    <search-form ref="form" size="mini" labelWidth="150px" :searchData="searchData" :searchForm="searchForm"
                        :viewdataVisible="isDisabled"></search-form>
                </div>
                <div style="display: flex">
                    <div style="width: 70%">
                        <el-form-item :label="$t('gloss_value')" prop="glossValue">
                            <el-input v-model="dataForm.glossValue" :placeholder="$t('gloss_value')" size="small"
                                @input="selectGlossInfo()" style="width: 100%" :disabled ="isDisabled"></el-input>
                        </el-form-item>
                    </div>
                    <div style="width: 30%">
                        <el-form-item label="" prop="gloss" label-width="20px">
                            <el-select v-model="dataForm.gloss" size="small" placeholder="" style="width: 100%"
                            disabled>
                                <el-option v-for="item in productGlossList" :key="item.id" :label="item.name"
                                    :value="item.id" size="small"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>

                <el-form-item label="">
                    <el-collapse @change="handleChange">
                        <el-collapse-item>
                            <span class="collapse-title" slot="title">{{
                                $t('view_standards')
                            }}</span>
                            <div style="display: flex">
                                <div style="width: 60%">
                                    <template v-for="(item, index) in glossList">
                                        <p v-if="index % 2 == 0" class="ziti">
                                            {{ localizeParam(item, 'label') }}
                                        </p>
                                    </template>
                                </div>
                                <div style="width: 60%">
                                    <template v-for="(item, index) in glossList">
                                        <p v-if="index % 2 == 1" class="ziti">
                                            {{ localizeParam(item, 'label') }}
                                        </p>
                                    </template>
                                </div>
                            </div>
                        </el-collapse-item>
                    </el-collapse>
                </el-form-item>
                <div style="display: flex">
                    <div style="width: 50%">
                        <el-form-item :label="$t('sample_panel_quantity')" prop="modelSum">
                            <el-input v-model="dataForm.modelSum" :placeholder="$t('sample_panel_quantity')"
                                size="small"><template slot="append">{{ $t('number_panels') }}</template></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('sample_poweder_quantity')" prop="materialSum">
                            <el-input v-model="dataForm.materialSum" :placeholder="$t('sample_poweder_quantity')"
                                size="small"><template slot="append">{{ $t('kg') }}</template></el-input>
                        </el-form-item>
                    </div>
                    <div style="width: 50%">
                        <el-form-item :label="$t('expected_completion_date')" prop="deliverDate">
                            <el-date-picker @change="handleChange" v-model="dataForm.deliverDate" type="date"
                                :placeholder="$t('expected_completion_date')" value-format="yyyy-MM-dd"></el-date-picker>
                        </el-form-item>
                        <el-form-item label=""> </el-form-item>
                    </div>
                </div>
                <el-form-item :label="$t('other_remarks')" prop="description">
                    <div style="margin: 5px 0"></div>
                    <el-input type="textarea" :rows="5" :placeholder="$t('other_remarks')" v-model="dataForm.description"
                        maxlength="150" show-word-limit>
                    </el-input>
                </el-form-item>

            </el-form>
        </div>
        <div slot="soltFooter">
            <span slot="footer">
                <el-button @click="close()" size="small">{{ $t('cancel') }}</el-button>
                <el-button type="primary" @click="dataFormSubmit()" size="small" :disabled="dataLoading">{{ $t('confirm')
                }}</el-button>
            </span>
        </div>
    </sides-lip>
</template>
  
<script>
import {
    getFactoryBrand,
    getDict,
    getFactory1,
    getBrand,
    getHex
} from '@/api/modules/product'
import SidesLip from '@/components/SidesLip'
import SearchForm from '@/components/form.vue'
import {
    getAttrAndValueListInfo,
    getGlossInfo,
    selectGlossInfo
} from '@/api/modules/productattr'
import {
    getProductAttrValue,
    selectChildAttr
} from '@/api/modules/productattrvalue'
import {
    selectProductAttrInfo,
    selectProductLabelInfo
} from '@/api/modules/productnorule'
import { selectLabelList } from '@/api/modules/productlabel'
import { addRemoyeProofong } from '@/api'
import ImageUpload from '../../components/imageUpload.vue'


export default {
    components: {
        SidesLip,
        SearchForm,
        ImageUpload
    },
    data() {
        return {
            proposItem:{},
            addMethod: undefined,
            updateMethod: undefined,
            proposList:{},
            searchForm: [
            ],
            searchData: {
            },
            searchDataProps:{},
            dialogVisible: false,
            biaoZhun: false,
            showLAB: false,
            loading: false,
            olabShow: false,
            visible: false,
            dataLoading: false,
            isBaseCheck: false,
            timer: null, //首先我在data函数里面进行定义定时器名称：
            timerNum: 0, // 设置定时器时间
            productLAB: {
                title: ['L*', 'a*', 'b*'],
                data: ['25°', '45°', '75°']
            },
            FactoryBrand: {},
            factoryId: '',
            isProductNoValid: true,
            isCopy: false,
            isDisabled: false,
            dataForm: {
                id: 0,
                picUrl: '',
                productImages: [],
                qrUrl: '',
                gloss: '',
                glossValue: '',
                hex: '',
                description: '',
                l1: '',
                a1: '',
                b1: '',
                l2: '',
                a2: '',
                b2: '',
                l3: '',
                a3: '',
                b3: '',
                lo: '',
                ao: '',
                bo: '',
                lAve: '',
                aAve: '',
                bAve: '',
                delFlag: '',
                createBy: '',
                createDate: '',
                updateBy: '',
                updateDate: '',
                deliverDate:'',
                productNumber:'',
                modelSum:'',
                materialSum:''

            },
            labArry:[],
            performanceList: [],
            industryList: [],
            industryList_child: [],
            colorSeriesList: [],
            productCategoryList: [],
            otherPerformanceList: [],
            productSeriesList: [],
            productGlossList: [],
            productSurfaceList: [],
            productHierarchyList: [],
            factoryList: [],
            labelList: [],
            brandList: [],
            glossList: [],
            dataRule: {
                lAve: [
                    {
                        required: true,
                        message: this.$t('e706', { x: this.$t('l_measurement') }),
                        trigger: 'blur'
                    }
                ],
                aAve: [
                    {
                        required: true,
                        message: this.$t('e706', { x: this.$t('a_measurement') }),
                        trigger: 'blur'
                    }
                ],
                bAve: [
                    {
                        required: true,
                        message: this.$t('e706', { x: this.$t('b_measurement') }),
                        trigger: 'blur'
                    }
                ],
                glossValue: [
                    {
                        required: true,
                        message: this.$t('e706', { x: this.$t('gloss') }),
                        trigger: 'blur'
                    }
                ]
            },
            productAttrId: '',
            attrValue: '',
            imageurl:''
        }
    },
    beforeDestroy() {
        window.clearInterval(this.timer)
        this.timer = null
        this.timerNum = 0
    },
    methods: {
        hanndlepImage(file){
             this.imageurl = file.url
        },
        getProductAttrValue() {
            let params = {}
            getProductAttrValue(params).then(({ data }) => {
                if (data && data.code === 0) {
                    for (var i = 0; i < data.list.length; i++) {
                        if (data.list[i].productAttrType === '1') {
                            //表面
                            this.productSurfaceList = data.list[i].productAttrValue
                        } else if (data.list[i].productAttrType === '3') {
                            //系列
                            this.productSeriesList = data.list[i].productAttrValue
                        } else if (data.list[i].productAttrType === '6') {
                            //主题
                            this.productHierarchyList = data.list[i].productAttrValue
                        } else if (data.list[i].productAttrType === '2') {
                            //色系
                            this.colorSeriesList = data.list[i].productAttrValue
                        } else if (data.list[i].productAttrType === '7') {
                            //性能
                            this.performanceList = data.list[i].productAttrValue
                        } else if (data.list[i].productAttrType === '4') {
                            //应用
                            this.industryList = data.list[i].productAttrValue
                        } else if (data.list[i].productAttrType === '8') {
                            //功能
                            this.otherPerformanceList = data.list[i].productAttrValue
                        } else if (data.list[i].productAttrType === '5') {
                            //分类
                            this.productCategoryList = data.list[i].productAttrValue
                        } else if (data.list[i].productAttrType === '9') {
                            //光泽
                            this.productGlossList = data.list[i].productAttrValue
                        }
                    }
                }
            })
        },
        getHex() {
            var params = {
                lab:
                    this.dataForm.lAve +
                    ',' +
                    this.dataForm.aAve +
                    ',' +
                    this.dataForm.bAve
            }
            getHex(params).then(({ data }) => {
                if (data && data.code === 0) {
                    this.dataForm.hex = data.hex
                }
            })
        },
        selectChildAttr() {
            let params = {
                attrValueId: this.dataForm.industryId
            }
            selectChildAttr(params).then(({ data }) => {
                if (data && data.code === 0) {
                    this.industryList_child = data.list
                } else {
                    this.industryList_child = []
                }
                this.dataForm.industryId_child = ''
            })
        },
        handleChange(val) {
        },
        //LAB值按钮隐藏显示
        isShowLAB() {
            this.showLAB = !this.showLAB
        },
        isBiaoZhun() {
            this.biaoZhun = !this.biaoZhun
        },

        //根据光泽测试值显示光泽范围名称
        selectGlossInfo() {
            this.dataForm.glossValue = this.dataForm.glossValue.replace(/[^\d.]/g, '') // 清除“数字”和“.”以外的字符
            this.dataForm.glossValue = this.dataForm.glossValue.replace(
                /\.{2,}/g,
                '.'
            ) //只保留第一个. 清除多余的
            this.dataForm.glossValue = this.dataForm.glossValue
                .replace('.', '$#$')
                .replace(/\./g, '')
                .replace('$#$', '.')
            this.dataForm.glossValue = this.dataForm.glossValue.replace(
                /^(\-)*(\d+)\.(\d).*$/,
                '$1$2.$3'
            ) //只能输入两个小数
            if (
                this.dataForm.glossValue.indexOf('.') < 0 &&
                this.dataForm.glossValue != ''
            ) {
                //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
                this.dataForm.glossValue = parseFloat(this.dataForm.glossValue)
            }
            // this.$set(this.dataForm.glossValue,e)
            this.$set(this.searchData, '1-' + this.productAttrId, '')
            let params = {
                glossValue: this.dataForm.glossValue
                    ? parseInt(this.dataForm.glossValue)
                    : ''
            }
            selectGlossInfo(params).then(({ data }) => {
                if (data && data.code === 0) {
                    this.dataForm.gloss = this.localizeParam(data.data, 'name')
                    this.productAttrId = data.data.productAttrId
                    this.attrValue = data.data.id
                    this.$set(this.searchData, '1-' + this.productAttrId, this.attrValue)
                } else {
                    this.dataForm.gloss = ''
                }
            })
        },

        // 查询光泽值范围
        getGlossInfo() {
            let params = {}
            getGlossInfo(params).then(({ data }) => {
                if (data && data.code === 0) {
                    this.glossList = data.data[0].options
                } else {
                    this.glossList = ''
                }
            })
        },
        getResultMap() {
            this.getAttrResultMap()
            this.getLabelResultMap()
        },
        getLabelResultMap() {
            let params = {
                brandId: this.dataForm.brandId,
                productNo: this.dataForm.productNo,
                productLabel: this.dataForm.productLabel
            }
            selectProductLabelInfo(params).then(({ data }) => {
                if (data && data.code === 0) {
                    this.dataForm.productLabel = data.labelList
                }
            })
        },
            //获取产品光泽选项
    getProductGlossList() {
      let params = {
        type: '3'
      }
      getDict(params).then(({ data }) => {
        if (data && data.code === 0) {
          this.productGlossList = data.list
        } else {
          this.productGlossList = []
        }
      })
    },
        getAttrResultMap() {
            let params = {
                brandId: this.dataForm.brandId,
                productNo: this.dataForm.productNo,
                searchData: this.searchData
            }
            selectProductAttrInfo(params).then(({ data }) => {
                if (data && data.code === 0) {
                    this.searchData = data.resultMap
                }
            })
        },
        getAttrAndValueListInfo: function () {
            this.searchData = {}
            this.searchForm = []
            this.tableCols = []
            var params = {
                type: 'detail',
                isUniversal: '0'
            }
            getAttrAndValueListInfo(params).then(({ data }) => {
                if (data && data.code === 0) {
                    data.data.forEach((e) => {
                        var obj = { type: '', label: '', width: '180px' }
                        if (e.type == '1') {
                            // 如果是单选
                            obj.type = 'Select'
                            obj.options = e.options
                            obj.prop = e.type + '-' + e.productAttrId
                            obj.label = e.value
                            obj.isUniversal = e.isUniversal
                        }
                        if (e.type == '2') {
                            obj.type = 'SelectMultiple'
                            obj.options = e.options
                            obj.prop = e.type + '-' + e.productAttrId
                            obj.value = e.value
                            obj.isUniversal = e.isUniversal
                        }
                        if (e.type == '3') {
                            obj.type = 'Cascader'
                            obj.options = e.options
                            obj.prop = e.type + '-' + e.productAttrId
                            obj.value = e.value
                            obj.isUniversal = e.isUniversal
                        }
                        obj.label = this.localizeParam(e, 'label')
                        this.$set(this.searchData, e.productAttrId, e.value)
                        this.searchForm.push(obj)
                    })
                } else {
                    this.$message.error(data.msg)
                    this.loading2 = false
                }
            })
        },

        init(id, state, isDisabled, isCopy,addUpdateMethods,proposObject) {
            this.getAttrAndValueListInfo()
            this.getGlossInfo()
            this.isDisabled = isDisabled
            this.dataForm.id = id || 0
            var titleMessage =
                this.$t('create_new_remote_proofing')
            this.$refs.SidesLip.init(titleMessage, '900px', 'block')
            this.getFactoryBrandList()
            this.getProductAttrValue()
            this.getFactoryList()
            this.getBrandList()
            this.getLabelList()
            this.loading = false
            this.visible = true
            //新增远程打样时，带入主页面 LAB 值及其他
            if(proposObject.labStr){
                this.labArry = proposObject.labStr.split(/\s+/)
                this.dataForm.lAve = this.labArry[0]
                this.dataForm.aAve = this.labArry[1]
                this.dataForm.bAve = this.labArry[2]
                this.dataForm.hex = proposObject.hex
                this.searchData = proposObject.searchData
                this.dataForm.glossValue = proposObject.computeGloss
                this.dataForm.gloss = proposObject.attrNameValue
            }
            this.proposItem = proposObject.proposItem
            // 列表页卡片点击进入传值
            if(this.proposItem){
                this.isDisabled = true
                this.dataForm.productNumber = this.proposItem.productNo
                this.dataForm.lAve = (this.proposItem.lAve).toFixed(2)
                this.dataForm.aAve = (this.proposItem.aAve).toFixed(2)
                this.dataForm.bAve = (this.proposItem.bAve).toFixed(2)
                this.dataForm.picUrl = this.proposItem.picUrl
                this.dataForm.hex = this.proposItem.hex
                this.dataForm.glossValue = this.proposItem.glossValue
                this.searchData = this.proposItem.searchData
                this.dataForm.gloss = this.proposItem.searchGloss
                if(this.proposItem.productImages){
                    this.dataForm.productImages = this.proposItem.productImages
                }
            } 
            // // 详情页面点击进入传值
            this.proposList = proposObject.list
            if(this.proposList ){
                this.isDisabled = true
                this.dataForm.productNumber = this.proposList.productNo
                this.dataForm.lAve = this.proposList.lAve
                this.dataForm.aAve = this.proposList.aAve
                this.dataForm.bAve = this.proposList.bAve
                this.dataForm.hex = this.proposList.hex
                this.dataForm.glossValue = this.proposList.glossValue
                this.dataForm.picUrl = this.proposList.picUrl
                this.dataForm.gloss = proposObject.gloss
                // this.dataForm.productImages = this.proposList.productImages
            }
        },
        
        close() {
            this.clear();
            this.$refs.SidesLip.sideClose()
        },

        sidesClose() {
            this.clear();
        },

        clear() {
                this.dataForm.productNumber = '',
                this.dataForm.lAve = '',
                this.dataForm.aAve = '',
                this.dataForm.bAve = '',
                this.dataForm.picUrl = '',
                this.dataForm.hex = '',
                this.dataForm.productImages = [],
                this.dataForm.glossValue = '',
                this.dataForm.gloss = '',
                this.dataForm.modelSum = '',
                this.dataForm.materialSum = '',
                this.dataForm.deliverDate = '',
                this.dataForm.description = '',
                this.searchData = {}
                this.performanceList = []
                //清除缓存数据
                this.$refs['dataForm'].resetFields()
        },

        // 表单提交
        dataFormSubmit() {
            let obj = {};
            for (let key in this.searchData) {
                this.searchForm.map((item) => {
                    if (key == item.prop && this.searchData[key]) {
                        if (typeof this.searchData[key] == 'object' && this.searchData[key].length > 0) {
                            this.searchData[key].map((item_1) => {
                                item.options.map((item_2) => {
                                    if (item_2.value == item_1) {
                                        if (obj[item.label]) {
                                            obj[item.label] = obj[item.label] + ',' + item_2.label
                                        } else {
                                            obj[item.label] = item_2.label
                                        }

                                    }
                                })
                            })
                        } else {
                            item.options.map((t) => {
                                if (t.value == this.searchData[key]) {
                                    obj[item.label] = t.label
                                }
                            })
                        }
                    }
                })
            }
            this.$refs['dataForm'].validate((valid) => {
                var verification = this.$refs.form.verification()
                if (valid && this.isProductNoValid) {
                    if (verification) {
                        this.$message.warning(this.$t('e706', { x: verification.label }))
                    } else {
                        this.dataLoading = true
                        var params = {
                            productNumber: this.dataForm.productNumber,
                            lAve: this.dataForm.lAve,
                            aAve: this.dataForm.aAve,
                            bAve: this.dataForm.bAve,
                            picUrl: this.dataForm.picUrl,
                            hex: this.dataForm.hex,
                            productImages: this.dataForm.productImages,
                            glossValue: this.dataForm.glossValue,
                            gloss: this.dataForm.gloss,
                            modelSum: this.dataForm.modelSum,
                            materialSum: this.dataForm.materialSum,
                            deliverDate: this.dataForm.deliverDate,
                            description: this.dataForm.description,
                            searchData: this.searchData,
                            searchValueData:obj
                        }
                        var tick = addRemoyeProofong({ ...params })
                        tick.then(({ data }) => {
                            if (data && data.code === 0) {
                                this.$message({
                                    message: this.$t('success'),
                                    type: 'success',
                                    duration: 1500,
                                    onClose: () => {
                                        this.dataLoading = false
                                        this.$emit('refreshDataList')
                                        this.$refs.SidesLip.sideClose()
                                    }
                                })
                            } else {
                                this.$message.error(data.msg)
                                this.dataLoading = false
                            }
                        })
                    }
                }
            })
            this.clear();
        },
        //获取工厂和品牌
        getFactoryBrandList() {
            let params = {}
            getFactoryBrand(params).then(({ data }) => {
                if (data && data.code === 0) {
                    this.FactoryBrand = data.factoryBrand
                } else {
                    this.FactoryBrand = {}
                }
            })
        },
        //获取工厂列表
        getFactoryList() {
            let params = {}
            getFactory1(params).then(({ data }) => {
                if (data && data.code === 0) {
                    this.factoryList = data.list
                    if (
                        data.factoryId != null &&
                        data.factoryId != undefined &&
                        this.factoryList.length > 0
                    ) {
                        this.dataForm.makeFactory = this.factoryList[0].factoryName
                        this.setFactoryId()
                    }
                } else {
                    this.factoryList = []
                }
            })
        },
        //获取品牌列表
        getBrandList() {
            let params = {}
            getBrand(params).then(({ data }) => {
                if (data && data.code === 0) {
                    this.brandList = data.list
                } else {
                    this.brandList = []
                }
            })
        },
        //获取标签列表
        getLabelList() {
            let params = {
                all: '1'
            }
            selectLabelList(params).then(({ data }) => {
                if (data && data.code === 0) {
                    this.labelList = data.labelList
                } else {
                    this.labelList = []
                }
            })
        },
        setFactoryId() {
            this.factoryId = this.factoryList.find(
                (factory) => factory.factoryName == this.dataForm.makeFactory
            ).id
        },
        updateBaseCheck() {
            this.dataForm.isBase = this.isBaseCheck ? '1' : '0'
        },
        productNoChanged(data) {
            this.getResultMap()
            this.isProductNoValid = data.isProductNoValid
            this.dataForm.productNo = data.productNo
            this.dataForm.productMainNo = data.productMainNo
            this.dataForm.productComponentNo = data.productComponentNo
            this.dataForm.productVersionNo = data.productVersionNo
        }
    }

}
</script>
<style lang="scss" scoped>
.color-preview {
    height: 80px;
    width: 80px;
    margin-top: 10%;
}

.disabled-color-preview {
    height: 60px;
    width: 60px;
    margin-top: 0px;
}

.ziti {
    font-size: 12px;
    margin: 0px;
    line-height: 25px;
}

.productLAB {
    margin: 0;
    padding: 0;
    margin-top: 5px;
    margin-left: -50px;

    li {
        list-style: none;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        margin-bottom: 10px;

        .title {
            display: inline-block;
            width: 160px;
            text-align: center;
            color: #606266;
            font-size: 700;
        }

        .ptitle {
            display: inline-block;
            width: 160px;
            text-align: center;
            font-size: 10px;
        }
    }
}

.w100 {
    width: 100px;
}

.w150 {
    width: 115px;
}

.mr10 {
    margin-right: 5px;
}

.collapse-title {
    flex: 1 0 90%;
    color: #4ab7bd;
    font-weight: bolder;
    text-align: center;
}

.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
    margin-bottom: 38px;
}

.el-form-item__label {
    width: auto;
}
</style>
  